/* global axios */
import ApiClient from './ApiClient';

// Reconciliación de mensajes de la IA (n8n → Twilio) como notas privadas.
class AiBackfillAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  run(conversationId) {
    return axios.post(`${this.url}/${conversationId}/ai_backfill`);
  }
}

export default new AiBackfillAPI();
